import script from "./Modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Modal.vue?vue&type=script&setup=true&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=0d5e7d7c&lang=scss&scoped=true"

import exportComponent from "/builds/ext/ERCO/productdata-archive-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d5e7d7c"]])

export default __exports__